/* eslint-disable max-len */
import * as R from 'ramda';

export default function ControlMainController(
  $scope,
  $q,
  userService,
  controlSharedModelService,
  controlDataService,
  bulkDeleteControlsDialog,
  syncControlTypeDialog,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.canExpand = true;
  vm.isExpanded = false;

  vm.handleExpandControlClick = _handleExpandControlClick;
  vm.handleBulkDeleteClick = _handleBulkDeleteClick;
  vm.handleSyncClick = _handleSyncClick;

  vm.hasData = false;

  _activate();

  function _activate() {
    _initPermissions();
    _initControlData();
    _initEventListeners();
    if (vm.isAssign === true) {
      vm.appendToSelector = '#assignControlDialog';
    } else {
      vm.appendToSelector = '';
    }
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('admin').then((permissions) => {
      vm.permissions = permissions;
    });
  }

  function _initControlData() {
    if (vm.controlDetail) {
      vm.controlDetail = controlSharedModelService.transformToEffectivenessCssClass(vm.controlDetail);
    }
  }

  function _initEventListeners() {
    $scope.$on(
      'refreshControlType', (event, payload) => {
        if (payload.customerControlTypeId === vm.controlDetail.customerControlTypeId) {
          _refreshControlType(vm.controlDetail.customerControlTypeId);
        }
      }
    );
  }

  function _handleExpandControlClick() {
    if (!vm.hasData) {
      controlDataService.getCustomerInitControlTypeControls(vm.controlDetail.customerControlTypeId).then((response) => {
        vm.controlDetail.customerControls = angular.copy(response.data.result);
        vm.controlDetail = controlSharedModelService.transformToEffectivenessCssClass(vm.controlDetail);
        vm.hasData = true;
        vm.isExpanded = !vm.isExpanded;
      });
    } else {
      vm.isExpanded = !vm.isExpanded;
    }
  }

  function _refreshControlType(customerControlTypeId) {
    const dfdItem = $q.defer();
    controlDataService.init().then((response) => {
      const controlTypeList = response.data.ControlTypes.result;
      const controlType = R.filter(
        R.propEq('customerControlTypeId', customerControlTypeId),
        controlTypeList
      );
      vm.controlDetail = Object.assign(vm.controlDetail, controlType[0]);
      controlDataService.getCustomerInitControlTypeControls(vm.controlDetail.customerControlTypeId).then((initResponse) => {
        vm.controlDetail.customerControls = angular.copy(initResponse.data.result);
        vm.controlDetail = controlSharedModelService.transformToEffectivenessCssClass(vm.controlDetail);

        controlSharedModelService.transformControl(vm.controlDetail);
        if (vm.controlDetail.customerControls && vm.controlDetail.customerControls.length > 0) {
          R.forEach((item) => {
            item.customerControlType = vm.controlDetail;
          }, vm.controlDetail.customerControls);
        }
        _initControlData();
        if (!vm.isExpanded) {
          vm.isExpanded = true;
        }
        dfdItem.resolve();
      });
    });

    return dfdItem.promise;
  }

  function _handleBulkDeleteClick($event) {
    if (!vm.hasData) {
      controlDataService.getCustomerInitControlTypeControls(vm.controlDetail.customerControlTypeId).then((response) => {
        vm.controlDetail.customerControls = angular.copy(response.data.result);
        vm.controlDetail = controlSharedModelService.transformToEffectivenessCssClass(vm.controlDetail);
        vm.hasData = true;
        showBulkDeleteAssetsDialog($event);
      });
    } else {
      showBulkDeleteAssetsDialog($event);
    }
  }

  function showBulkDeleteAssetsDialog($event) {
    ssDialogService.dialogs.riskAdmin.bulkDeleteRisksDialog = ssDialogService.alert(
      bulkDeleteControlsDialog.getOptions($event, {
        controlType: vm.controlDetail,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.riskAdmin.bulkDeleteRisksDialog);
  }

  function _handleSyncClick($event) {
    // loaderService.showViewLoader = true;
    // controlDataService.getAssetTypeWithInstances(vm.assetType.customerAssetTypeId)
    //   .then((getAssetTypeResponse) => {
    //     vm.assetTypeOfSync = angular.copy(vm.assetType);
    //     Object.assign(vm.assetTypeOfSync, getAssetTypeResponse.data);
    //     loaderService.showViewLoader = false;
    _showSyncControlTypeDialog($event);
    // });
  }

  function _showSyncControlTypeDialog($event) {
    loaderService.showViewLoader = true;
    ssDialogService.dialogs.controlAdmin.syncControlTypeDialog = ssDialogService.alert(
      syncControlTypeDialog.getOptions($event, {
        controlType: angular.copy(vm.controlDetail),
      })
    );
    loaderService.showViewLoader = false;
    ssDialogService.show(ssDialogService.dialogs.controlAdmin.syncControlTypeDialog);
  }
}

ControlMainController.$inject = [
  '$scope',
  '$q',
  'userService',
  'controlSharedModelService',
  'controlDataService',
  'bulkDeleteControlsDialog',
  'syncControlTypeDialog',
  'loaderService',
  'ssDialogService',
];
